import type { AnalyticsEvent } from "@packages/analytics";
import { HallowAnalyticsEvent } from "@packages/analytics";

import type { AuthFlow, AuthProps } from "./AuthTypes.emotion";

export const SMS_PROMPT_SCREEN_NAME = "sms_prompt";

export type HandleSmsConsentChoiceProps = Pick<AuthProps, "onAuth"> & {
  isConsenting: boolean;
  isTargetedSmsPrompt?: boolean;
  requestConsent: (consented: boolean) => Promise<unknown>;
  setFlow: (flow: AuthFlow) => void;
  skipNamesCollection?: boolean;
  track: (event: AnalyticsEvent) => unknown;
};

export const handleSmsConsentChoice = async ({
  isConsenting,
  isTargetedSmsPrompt,
  onAuth,
  requestConsent,
  setFlow,
  skipNamesCollection,
  track,
}: HandleSmsConsentChoiceProps) => {
  try {
    await requestConsent(isConsenting);
  } catch {}

  track({
    event: isConsenting
      ? HallowAnalyticsEvent.CompletedOnboardingStep
      : HallowAnalyticsEvent.SkippedOnboardingStep,
    properties: {
      screen_name: SMS_PROMPT_SCREEN_NAME,
    },
  });

  if (isTargetedSmsPrompt && !skipNamesCollection) return setFlow("sms_prompt");

  if (!skipNamesCollection) setFlow("names");
  else onAuth?.({ isNewUser: true });
};
